// Cienka warstwa nad fetch. Wszystkie wywolania API ida przez nia,
// zeby obsluga bledow i bazowy adres byly w jednym miejscu.

const BASE = "/api/v1";

export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export async function apiGet<T>(path: string): Promise<T> {
  const response = await fetch(`${BASE}${path}`);
  if (!response.ok) {
    throw new ApiError(`Blad zapytania ${path}`, response.status);
  }
  return (await response.json()) as T;
}

export interface Status {
  app: string;
  env: string;
  execution_mode: "paper" | "live";
  modules: Record<string, string>;
}

export const getStatus = () => apiGet<Status>("/status");
